import { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import utils, { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import {useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_NOTI_HIST_INFO } from "@/tra/tancis/ptli/mypage/notihist/services/PtliNotiHistService";

/*
 * Notifice History Details
 * !== 알림현황(SMS/Mail) 상세 ==!
 */
export const PTLI0308002Q = (): JSX.Element => {
    const {pgeUid, menuId} = usePage({
        auth: ["auth_ptli0019"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { notiSendUuid } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
           
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Notifice Information !== 알림 정보 ==!
        notiHistInfo: useForm({
            defaultSchema: SF_NOTI_HIST_INFO,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Notifice History Details !== 알림 이력 상세 조회 ==!
        getNotiHistInfo: useFetch({
            api: () => APIS.getNotiHistInfo(notiSendUuid),
            enabled: !!notiSendUuid,
            onSuccess: (data) => {
                const notiHistInfo = data.notiHistInfo.content;

                form.notiHistInfo.setValues(notiHistInfo);
            },
            onError: (error) => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getNotiHistInfo.fetch();
        form.notiHistInfo.setEditable(false);
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                        <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiMsgCn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiTp}></Group.Control>
                                <Group.Control {...form.notiHistInfo.schema.sendDtm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.sndrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.sndrEmlAddr}></Group.Control>
                                <Group.Control {...form.notiHistInfo.schema.sndrTelno}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="list"
                                    onClick={() => {
                                        navigate(URLS.ptli0308001q);
                                    }}
                                ></Button>
                            </Layout.Left>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>
        </Page>
    );
};
